<app-loader></app-loader>
<div class="container">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-6 text-center">
      <div class="imagenes-montadas imagenes-montadas-xl mt-4">
        <img [src]="backgroundImage" width="50%" class="rounded-circle img-thumbnail" style="z-index: 2;">
        <img [src]="global.urlServer + 'img/hombre-register.png'" width="40%" class="rounded-circle img-thumbnail" style="z-index: 1;">
      </div>
      <h5 class="mt-5 text-iguau">Donde las mascotas hacen amigos</h5>
      <div class="mt-3 mb-3 text-body-secondary">
        Entra en <b>iGuau</b> y sigue descubriendo una comunidad llena de mascotas y amantes de los animales. 
        Explora nuevos perfiles, conoce a otros compañeros peludos y encuentra nuevas amistades para pasear, jugar y compartir momentos inolvidables. 
        Inicia sesión y continúa formando parte del lugar donde las mascotas también hacen amigos
      </div>
    </div>
    <div class="col bg-white p-5 rounded div-shadow">
      <div *ngIf="!regenerate">
        <div class="mb-3 text-iguau"><b>Nueva contraseña</b></div>

        <form [formGroup]="form">

        <div class="form-group mb-3 position-relative" *ngIf="aviso==''">
          <i class="fa-solid fa-lock icon-input"></i>
          <input [type]="showPassword ? 'text' : 'password'" class="form-control ps-5 pe-5" placeholder="Contraseña" (keyup)="error=''"
                formControlName="password" autocomplete="current-password" required maxlength="200">
          <i class="toggle-eye fa-solid" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" (click)="togglePassword()"></i>
        </div>

        <div class="form-group mb-3 position-relative" *ngIf="aviso==''">
          <i class="fa-solid fa-lock icon-input"></i>
          <input [type]="showPassword ? 'text' : 'password'" class="form-control ps-5 pe-5" placeholder="Confirmar contraseña" (keyup)="error=''"
                formControlName="passwordconf" autocomplete="current-password" required maxlength="200">
          <i class="toggle-eye fa-solid" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" (click)="togglePassword()"></i>
        </div>

        <div class="mb-3 alert alert-success" role="alert" *ngIf="aviso!=''">
          <i class="fa-solid fa-triangle-exclamation pe-2 fs-4"></i><span [innerHTML]="aviso"></span>
        </div>
        <div class="mb-3 alert alert-danger" role="alert" *ngIf="error!=''">
          <i class="fa-solid fa-triangle-exclamation pe-2 fs-4"></i><span [innerHTML]="error"></span>
        </div>

        <div class="mt-3 d-grid gap-2" *ngIf="aviso==''">
          <button class="btn btn-primary" type="button" [disabled]="form.invalid || busy" (click)="regenerarPassword()">
            <div class="spinner-border spinner-border-sm" role="status"
                *ngIf="busy">
              <span class="visually-hidden">Loading...</span>
            </div>
            Cambiar
          </button>
        </div>
        <div class="mt-3 d-grid gap-2" *ngIf="aviso!=''">
          <button class="btn btn-primary" type="button" (click)="acceder()">Acceder</button>
        </div>

        </form>
      </div>
     
    </div>
  </div>
</div>